import { Component } from '@angular/core';

@Component({
  selector: 'app-registry-recap-isv',
  templateUrl: './registry-recap-isv.component.html',
  styleUrl: './registry-recap-isv.component.scss'
})
export class RegistryRecapIsvComponent {

}
